import Cookies from 'js-cookie';

import { withForterHeaders } from 'state/graphql/links/with-forter-headers';

export const getForterToken = () => {
  const cookieForterToken = Cookies.get('forterToken');
  return withForterHeaders.ttiForterToken ?? cookieForterToken;
};

enum ScanType {
  SCAN_REWARDS = '|SR|',
  APPLE_WALLET = '|AW|',
}

interface ICreateScanAndPayBarcode {
  baseBarcode?: string;
  forterToken?: string;
  paymentMethodId?: string;
  userId?: string;
}

export const createScanAndPayBarcode = ({
  baseBarcode = '',
  forterToken = '',
  paymentMethodId = '',
  userId = '',
}: ICreateScanAndPayBarcode) => {
  // @see https://rbictg.atlassian.net/wiki/spaces/CPT/pages/3648421917/Scan+Pay#Barcode-token-anatomy
  const rbiTechValues = `$U${userId}|P${paymentMethodId}|F${forterToken}`;
  return `${baseBarcode}${rbiTechValues}`;
};

export const createBaseBarcode = (
  barcode: string = '',
  scanType: ScanType = ScanType.SCAN_REWARDS
) => {
  if (!barcode) {
    return '';
  }
  if (scanType) {
    return `${barcode}${scanType}`;
  }
  return barcode;
};
